export default __webpack_public_path__ + "images/bf4a3be5bea99434451dfbced3990b86-control.svg";